import React from "react";

const colors = [
  "#1f77b4", // Dark blue
  "#ff7f0e", // Orange
  "#2ca02c", // Green
  "#d62728", // Red
  "#9467bd", // Purple
  "#8c564b", // Brown
  "#e377c2", // Pink
  "#ff9896", // Brighter pink
  "#bcbd22", // Olive
  "#17becf", // Light blue
  "#ff33cc", // Magenta
];

const Legend = () => {
  return (
    <ul className="legend-container">
      {colors.map((color, index) => (
        <li key={index} className="legend-item"> 
        <span className="legend-color" style={{backgroundColor: color}}></span>
        <span className="legend-label">{getLabel(index)}</span>

        </li>
      ))}
    </ul>
  );
};

// Helper function to get the corresponding label based on the index
const getLabel = (index) => {
  const labels = [
    "Ordförande",
    "Kassör",
    "Byggchef",
    "Bilchef",
    "Gårdvar",
    "Klädchef",
    "Programchef",
    "Annonschef",
    "Musikchef",
    "Ölchef",
    "PR-chef",
  ];
  return labels[index];
};

export default Legend;
